import { assignJob, getFreePopulation, MAX_MILITIA } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireMilitiaAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.barracks.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_MILITIA * settlement.buildings.barracks.qty;
    if (settlement.jobs.militia >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'militia')) return false;
    return true;
};
